<div [@dialog] (@dialog.done)="animationEnded($event)" *ngIf="visible" class="dialogModal" [style.width]="modalWidth ? modalWidth: ''" [style.top]="modalTop ? modalTop: ''" [style.min-height]="modalMinHeight ? modalMinHeight: ''">
    <ng-content></ng-content>
    <button type="button" *ngIf="closable" (click)="close()" aria-label="Close" class="dialogModal__close-btn" style="cursor: pointer;" [style.color]="closeColor"><i class="fa fa-times" style="color: #fff;" aria-hidden="true"></i>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              </svg>
        </button>
</div>
<div *ngIf="visible" class="overlay" (click)="cancelable && close()"></div>
